import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policies/create/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.POLICIES });
    context.validatePermissions({ isAllowed, preload });
  },
});
